import Swiper, {Navigation, Pagination, Autoplay} from 'swiper'
Swiper.use([Navigation, Pagination, Autoplay]);

export default function sliders() {
    (function($) {
        $(window).on('load', function () {
           // get all sliders, we need to loop them due to different settings + nav
           var swipers = document.querySelectorAll('.review-swiper');
           swipers.forEach(function(el,index){
            var closestSection = el.closest('section');

                // slider settings
                var options = {
                    speed: 600,
                    loop: true,
                    spaceBetween: 14,
                    slidesPerView: 1,
                    autoHeight: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    }
                };

                // For gallery sliders

                // init slider
                new Swiper(el, options);
            });
       })


    })( jQuery );
}

